import { useUserStore } from '@st/user/stores/useUserStore'
import { useTagsStore } from '@st/user/stores/useTagsStore'
import { provideVerificationDeps } from '@st/verification/useDeps'
import { useCurrenciesStore } from '@st/payments/stores/useCurrenciesStore'
import { useConverterStore } from '@st/payments/stores/useConverterStore'

export default defineNuxtPlugin({
  name: 'verificationDeps',
  dependsOn: ['paymentsDeps'],
  setup: () => {
    const userStore = useUserStore()
    const { setKycLevel } = userStore
    const {
      isAuthenticated,
      isReady: isReadyUser,
      user,
    } = storeToRefs(userStore)

    const currencyStore = useCurrenciesStore()
    const { getCurrencyById } = currencyStore
    const { appCurrency } = toRefs(currencyStore)
    const { convert } = useConverterStore()
    const tagsStore = useTagsStore()
    const { hasTag } = tagsStore
    const { isReady: isReadyTags } = storeToRefs(tagsStore)

    /**
     * @TODO
     * getCurrencyById может вернуть undefined?
     */

    provideVerificationDeps({
      hasSkipKycLevelCheckOnDepositTag: computed(() =>
        hasTag('skipKycLevelCheckOnDeposit'),
      ),
      isAuthenticated,
      isReadyUser,
      isReadyTags,
      userKycLevel: computed(() => user.value?.kycLevel ?? null),
      appCurrencyCode: computed(() => appCurrency.value.code),
      getCurrencyIcon: (id: number) => getCurrencyById(id)?.icon,
      getFiatAmount: (currencyId: number, amount: string) =>
        convert(amount, { from: currencyId, to: appCurrency.value.id }),
      setKycLevel,
    })
  },
})
